import React, { PureComponent } from 'react';

import RepositoryAccessGuard from 'src/sections/repository/components/repository-access-guard';

import { DetailedBranch } from '../types';

import CreatePullRequestLink from './branch-table/create-pull-request-link';
import PullRequestListDialog from './dialogs/pull-request-list-dialog';
import PullRequestShortRow from './pull-request-short-row';

type Props = {
  branch: DetailedBranch;
};

export default class BranchPullRequests extends PureComponent<Props> {
  render() {
    const { branch } = this.props;
    const { pullRequests } = branch;

    if (!pullRequests) {
      return null;
    }

    if (pullRequests.length === 0) {
      const showCreatePrLink =
        !branch.isMainBranch && (branch.ahead == null || branch.ahead > 0);

      return showCreatePrLink ? (
        <RepositoryAccessGuard requiredLevel="write">
          <CreatePullRequestLink branchName={branch.name} />
        </RepositoryAccessGuard>
      ) : null;
    }

    if (pullRequests.length === 1) {
      const [pullRequest] = pullRequests;

      return <PullRequestShortRow pullRequest={pullRequest} hideTitle />;
    }

    return <PullRequestListDialog pullRequests={pullRequests} />;
  }
}
